import type { IntentRule, ReportSeverity } from '@ipfabric/utils';

/**
 * intentCheckResult is defined as 'intentCheckResult?: ReportSeverity | null' in graph-utils.
 * intentCheckResult is not sent if there is no intent overlay.
 * Otherwise, it can be null if no intent check is applied.
 */
export const hasEntityAppliedCustomIntentCheck = (
  intentCheckResult?: ReportSeverity | null,
  intentRule?: IntentRule | null,
): boolean =>
  intentCheckResult !== undefined &&
  intentCheckResult !== null &&
  intentRule?.id !== 'singlePointsOfFailure' &&
  intentRule?.id !== 'nonRedundantEdges';
